(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haztoria-dynamic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haztoria-dynamic')) {
  customElements.define('haztoria-dynamic', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-slide-to')) this.showSlide(Number(button.dataset.slideTo));
        if (button.hasAttribute('data-direction')) this.showSlide(this.index + Number(button.dataset.direction));
        if (button.hasAttribute('data-filter')) this.filter(button.dataset.filter);
        if (button.hasAttribute('data-style')) {
          this.filter(button.dataset.style);
          const target = this.querySelector('.hz-catalog');
          target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
          this.querySelector('[data-filter="' + button.dataset.style + '"]').focus({preventScroll:true});
        }
        if (button.hasAttribute('data-motion')) {
          const paused = this.querySelector('.hz-ticker').classList.toggle('is-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
          button.textContent = paused ? '▶' : 'Ⅱ';
        }
        if (button.hasAttribute('data-quick-open')) {
          this.opener = button;
          const template = button.closest('.hz-product').querySelector('template');
          this.querySelector('[data-quick-body]').replaceChildren(template.content.cloneNode(true));
          this.dialog.showModal();
        }
        if (button.hasAttribute('data-quick-close')) this.dialog.close();
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => this.opener?.focus({preventScroll:true}));
      this.filter('all');
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelectorAll('[data-slide-to]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
    }
    filter(category) {
      let count = 0;
      this.querySelectorAll('[data-category]').forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; if (!card.hidden) count++; });
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      const result = this.querySelector('[data-results]');
      result.textContent = count + ' ' + result.dataset.label;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
